import axios from "axios";

export default axios.create({
/*  baseURL: "http://localhost:8002",*/
  //baseURL: "https://www.tebelopele.org.bw/myhealthassessment/",
  baseURL: "https://www.tebelopeleclinics.org.bw/myhealthassessment/",
  headers: {
    //"Content-type": "application/json"
  }
});
